/**
 * Copyright (c) Microsoft. All rights reserved.
 */

export type Language =
    | { code: string; name: string }
    | { code: 'af'; name: 'Afrikaans' }
    | { code: 'sq'; name: 'Albanian' }
    | { code: 'am'; name: 'Amharic' }
    | { code: 'ar'; name: 'Arabic' }
    | { code: 'hy'; name: 'Armenian' }
    | { code: 'as'; name: 'Assamese' }
    | { code: 'az'; name: 'Azerbaijani' }
    | { code: 'bn'; name: 'Bangla' }
    | { code: 'ba'; name: 'Bashkir' }
    | { code: 'eu'; name: 'Basque' }
    | { code: 'be'; name: 'Belarusian' }
    | { code: 'bs'; name: 'Bosnian' }
    | { code: 'bg'; name: 'Bulgarian' }
    | { code: 'my'; name: 'Burmese' }
    | { code: 'ca'; name: 'Catalan' }
    | { code: 'km'; name: 'Central Khmer' }
    | { code: 'zh'; name: 'Chinese' | 'Chinese-Simplified' }
    | { code: 'zh-chs'; name: 'Chinese-Simplified' }
    | { code: 'zh-cht' | 'zh-hant'; name: 'Chinese-Traditional' }
    | { code: 'co'; name: 'Corsican' }
    | { code: 'hr'; name: 'Croatian' }
    | { code: 'cs'; name: 'Czech' }
    | { code: 'da'; name: 'Danish' }
    | { code: 'prs'; name: 'Dari' }
    | { code: 'dv'; name: 'Divehi' }
    | { code: 'nl'; name: 'Dutch' }
    | { code: 'en'; name: 'English' }
    | { code: 'eo'; name: 'Esperanto' }
    | { code: 'et'; name: 'Estonian' }
    | { code: 'fi'; name: 'Finnish' }
    | { code: 'fj'; name: 'Fijian' }
    | { code: 'fr'; name: 'French' }
    | { code: 'gl'; name: 'Galician' }
    | { code: 'ka'; name: 'Georgian' }
    | { code: 'de'; name: 'German' }
    | { code: 'el'; name: 'Greek' }
    | { code: 'gu'; name: 'Gujarati' }
    | { code: 'ht'; name: 'Haitian' }
    | { code: 'ha'; name: 'Hausa' }
    | { code: 'he'; name: 'Hebrew' }
    | { code: 'hi'; name: 'Hindi' }
    | { code: 'mww'; name: 'Hmong Daw' }
    | { code: 'hu'; name: 'Hungarian' }
    | { code: 'is'; name: 'Icelandic' }
    | { code: 'ig'; name: 'Igbo' }
    | { code: 'id'; name: 'Indonesian' }
    | { code: 'iu'; name: 'Inuktitut' }
    | { code: 'ga'; name: 'Irish' }
    | { code: 'it'; name: 'Italian' }
    | { code: 'ja'; name: 'Japanese' }
    | { code: 'jv'; name: 'Javanese' }
    | { code: 'kn'; name: 'Kannada' }
    | { code: 'kk'; name: 'Kazakh' }
    | { code: 'rw'; name: 'Kinyarwanda' }
    | { code: 'ky'; name: 'Kirghiz' }
    | { code: 'ko'; name: 'Korean' }
    | { code: 'ku'; name: 'Kurdish' }
    | { code: 'la'; name: 'Latin' }
    | { code: 'lo'; name: 'Lao' }
    | { code: 'lv'; name: 'Latvian' }
    | { code: 'lt'; name: 'Lithuanian' }
    | { code: 'lb'; name: 'Luxembourgish' }
    | { code: 'mk'; name: 'Macedonian' }
    | { code: 'mg'; name: 'Malagasy' }
    | { code: 'ml'; name: 'Malayalam' }
    | { code: 'ms'; name: 'Malay' }
    | { code: 'mt'; name: 'Maltese' }
    | { code: 'mi'; name: 'Maori' }
    | { code: 'mr'; name: 'Marathi' }
    | { code: 'mr-in'; name: 'Marathi' }
    | { code: 'mn'; name: 'Mongolian' }
    | { code: 'ne'; name: 'Nepali' }
    | { code: 'no'; name: 'Norwegian' }
    | { code: 'nn'; name: 'Norwegian Nynorsk' }
    | { code: 'or'; name: 'Odia' }
    | { code: 'ps'; name: 'Pashto' }
    | { code: 'fa'; name: 'Persian' }
    | { code: 'pl'; name: 'Polish' }
    | { code: 'pt'; name: 'Portuguese' | 'Portuguese (Portugal)' }
    | { code: 'pt-BR'; name: 'Portuguese (Brazil)' }
    | { code: 'pa'; name: 'Punjabi' }
    | { code: 'otq'; name: 'Queretaro Otomi' }
    | { code: 'ro'; name: 'Romanian' }
    | { code: 'ru'; name: 'Russian' }
    | { code: 'sm'; name: 'Samoan' }
    | { code: 'sa'; name: 'Sanskrit' }
    | { code: 'sn'; name: 'Shona' }
    | { code: 'sd'; name: 'Sindhi' }
    | { code: 'si'; name: 'Sinhala' }
    | { code: 'sr'; name: 'Serbian' }
    | { code: 'sk'; name: 'Slovak' }
    | { code: 'sl'; name: 'Slovenian' }
    | { code: 'so'; name: 'Somali' }
    | { code: 'es'; name: 'Spanish' }
    | { code: 'su'; name: 'Sundanese' }
    | { code: 'sw'; name: 'Swahili' }
    | { code: 'sv'; name: 'Swedish' }
    | { code: 'tl'; name: 'Tagalog' }
    | { code: 'ty'; name: 'Tahitian' }
    | { code: 'tg'; name: 'Tajik' }
    | { code: 'ta'; name: 'Tamil' }
    | { code: 'tt'; name: 'Tatar' }
    | { code: 'te'; name: 'Telugu' }
    | { code: 'th'; name: 'Thai' }
    | { code: 'bo'; name: 'Tibetan' }
    | { code: 'ti'; name: 'Tigrinya' }
    | { code: 'to'; name: 'Tongan' }
    | { code: 'tr'; name: 'Turkish' }
    | { code: 'tk'; name: 'Turkmen' }
    | { code: 'ug'; name: 'Uighur' }
    | { code: 'uk'; name: 'Ukrainian' }
    | { code: 'ur'; name: 'Urdu' }
    | { code: 'uz'; name: 'Uzbek' }
    | { code: 'vi'; name: 'Vietnamese' }
    | { code: 'cy'; name: 'Welsh' }
    | { code: 'xh'; name: 'Xhosa' }
    | { code: 'yi'; name: 'Yiddish' }
    | { code: 'yo'; name: 'Yoruba' }
    | { code: 'zu'; name: 'Zulu' }
    | { name: 'Oromo'; code: 'om' }
    | { name: 'Western Frisian'; code: 'fy' }
    | { name: 'Portuguese (Portugal)'; code: 'pt-PT' }
    | { name: 'Scottish Gaelic'; code: 'gd' }
    | { name: 'Filipino'; code: 'fil' }
    | { name: 'Chinese (Simplified)'; code: 'zh-hans' }
    | { name: 'Breton'; code: 'br' };

export const questionsAnsweringDemoSupportedLanguages: Language[] = [
    { code: 'af', name: 'Afrikaans' },
    { code: 'sq', name: 'Albanian' },
    { code: 'am', name: 'Amharic' },
    { code: 'ar', name: 'Arabic' },
    { code: 'hy', name: 'Armenian' },
    { code: 'as', name: 'Assamese' },
    { code: 'az', name: 'Azerbaijani' },
    { code: 'bn', name: 'Bangla' },
    { code: 'ba', name: 'Bashkir' },
    { code: 'eu', name: 'Basque' },
    { code: 'be', name: 'Belarusian' },
    { code: 'bg', name: 'Bulgarian' },
    { code: 'my', name: 'Burmese' },
    { code: 'ca', name: 'Catalan' },
    { code: 'km', name: 'Central Khmer' },
    { code: 'zh', name: 'Chinese' },
    { code: 'hr', name: 'Croatian' },
    { code: 'cs', name: 'Czech' },
    { code: 'da', name: 'Danish' },
    { code: 'nl', name: 'Dutch' },
    { code: 'en', name: 'English' },
    { code: 'eo', name: 'Esperanto' },
    { code: 'et', name: 'Estonian' },
    { code: 'fi', name: 'Finnish' },
    { code: 'fr', name: 'French' },
    { code: 'gl', name: 'Galician' },
    { code: 'ka', name: 'Georgian' },
    { code: 'de', name: 'German' },
    { code: 'el', name: 'Greek' },
    { code: 'gu', name: 'Gujarati' },
    { code: 'he', name: 'Hebrew' },
    { code: 'hi', name: 'Hindi' },
    { code: 'hu', name: 'Hungarian' },
    { code: 'is', name: 'Icelandic' },
    { code: 'id', name: 'Indonesian' },
    { code: 'ga', name: 'Irish' },
    { code: 'it', name: 'Italian' },
    { code: 'ja', name: 'Japanese' },
    { code: 'kn', name: 'Kannada' },
    { code: 'kk', name: 'Kazakh' },
    { code: 'ky', name: 'Kirghiz' },
    { code: 'ko', name: 'Korean' },
    { code: 'la', name: 'Latin' },
    { code: 'lo', name: 'Lao' },
    { code: 'lv', name: 'Latvian' },
    { code: 'lt', name: 'Lithuanian' },
    { code: 'mk', name: 'Macedonian' },
    { code: 'ml', name: 'Malayalam' },
    { code: 'ms', name: 'Malay' },
    { code: 'mt', name: 'Maltese' },
    { code: 'mr', name: 'Marathi' },
    { code: 'mn', name: 'Mongolian' },
    { code: 'ne', name: 'Nepali' },
    { code: 'no', name: 'Norwegian' },
    { code: 'nn', name: 'Norwegian Nynorsk' },
    { code: 'or', name: 'Odia' },
    { code: 'ps', name: 'Pashto' },
    { code: 'fa', name: 'Persian' },
    { code: 'pl', name: 'Polish' },
    { code: 'pt', name: 'Portuguese' },
    { code: 'pa', name: 'Punjabi' },
    { code: 'ro', name: 'Romanian' },
    { code: 'ru', name: 'Russian' },
    { code: 'sa', name: 'Sanskrit' },
    { code: 'sd', name: 'Sindhi' },
    { code: 'si', name: 'Sinhala' },
    { code: 'sr', name: 'Serbian' },
    { code: 'sk', name: 'Slovak' },
    { code: 'sl', name: 'Slovenian' },
    { code: 'es', name: 'Spanish' },
    { code: 'sw', name: 'Swahili' },
    { code: 'sv', name: 'Swedish' },
    { code: 'tl', name: 'Tagalog' },
    { code: 'tg', name: 'Tajik' },
    { code: 'ta', name: 'Tamil' },
    { code: 'tt', name: 'Tatar' },
    { code: 'te', name: 'Telugu' },
    { code: 'th', name: 'Thai' },
    { code: 'tr', name: 'Turkish' },
    { code: 'ug', name: 'Uighur' },
    { code: 'uk', name: 'Ukrainian' },
    { code: 'ur', name: 'Urdu' },
    { code: 'uz', name: 'Uzbek' },
    { code: 'vi', name: 'Vietnamese' },
    { code: 'cy', name: 'Welsh' },
    { code: 'yi', name: 'Yiddish' }
];

export const namedEntitiesDemoGAModelSupportedLanguages: Language[] = [
    { code: 'ar', name: 'Arabic' },
    { code: 'zh', name: 'Chinese-Simplified' },
    { code: 'zh-hant', name: 'Chinese-Traditional' },
    { code: 'cs', name: 'Czech' },
    { code: 'da', name: 'Danish' },
    { code: 'nl', name: 'Dutch' },
    { code: 'en', name: 'English' },
    { code: 'fi', name: 'Finnish' },
    { code: 'fr', name: 'French' },
    { code: 'de', name: 'German' },
    { code: 'he', name: 'Hebrew' },
    { code: 'hu', name: 'Hungarian' },
    { code: 'it', name: 'Italian' },
    { code: 'ja', name: 'Japanese' },
    { code: 'ko', name: 'Korean' },
    { code: 'no', name: 'Norwegian' },
    { code: 'pl', name: 'Polish' },
    { code: 'pt-BR', name: 'Portuguese (Brazil)' },
    { code: 'pt', name: 'Portuguese (Portugal)' },
    { code: 'ru', name: 'Russian' },
    { code: 'es', name: 'Spanish' },
    { code: 'sv', name: 'Swedish' },
    { code: 'tr', name: 'Turkish' }
];

export const namedEntitiesDemoPreviewModelSupportedLanguages: Language[] = [
    { name: 'Arabic', code: 'ar' },
    { name: 'Czech', code: 'cs' },
    { name: 'Danish', code: 'da' },
    { name: 'Dutch', code: 'nl' },
    { name: 'English', code: 'en' },
    { name: 'Finnish', code: 'fi' },
    { name: 'French', code: 'fr' },
    { name: 'German', code: 'de' },
    { name: 'Hebrew', code: 'he' },
    { name: 'Hindi', code: 'hi' },
    { name: 'Hungarian', code: 'hu' },
    { name: 'Italian', code: 'it' },
    { name: 'Japanese', code: 'ja' },
    { name: 'Korean', code: 'ko' },
    { name: 'Norwegian', code: 'no' },
    { name: 'Polish', code: 'pl' },
    { name: 'Portuguese', code: 'pt' },
    { name: 'Portuguese (Brazil)', code: 'pt-BR' },
    { name: 'Russian', code: 'ru' },
    { name: 'Chinese (Simplified)', code: 'zh-hans' },
    { name: 'Spanish', code: 'es' },
    { name: 'Swedish', code: 'sv' },
    { name: 'Chinese-Traditional', code: 'zh-hant' },
    { name: 'Turkish', code: 'tr' }
];

export const linkedEntitiesDemoSupportedLanguages: Language[] = [
    { code: 'en', name: 'English' },
    { code: 'es', name: 'Spanish' }
];

export const sentimentDemoSupportedLanguages: (Language & { isOpinionMiningSupported?: boolean })[] = [
    { name: 'Afrikaans', code: 'af' },
    { name: 'Albanian', code: 'sq' },
    { name: 'Amharic', code: 'am' },
    { name: 'Arabic', code: 'ar' },
    { name: 'Armenian', code: 'hy' },
    { name: 'Assamese', code: 'as' },
    { name: 'Azerbaijani', code: 'az' },
    { name: 'Basque', code: 'eu' },
    { name: 'Belarusian (new)', code: 'be' },
    { name: 'Bangla', code: 'bn' },
    { name: 'Bosnian', code: 'bs' },
    { name: 'Breton', code: 'br' },
    { name: 'Bulgarian', code: 'bg' },
    { name: 'Burmese', code: 'my' },
    { name: 'Catalan', code: 'ca' },
    { name: 'Chinese (Simplified)', code: 'zh-hans' },
    { name: 'Chinese (Traditional)', code: 'zh-hant' },
    { name: 'Croatian', code: 'hr' },
    { name: 'Czech', code: 'cs' },
    { name: 'Danish', code: 'da' },
    { name: 'Dutch', code: 'nl' },
    { name: 'English', code: 'en', isOpinionMiningSupported: true },
    { name: 'Esperanto (new)', code: 'eo' },
    { name: 'Estonian', code: 'et' },
    { name: 'Filipino', code: 'fil' },
    { name: 'Finnish', code: 'fi' },
    { name: 'French', code: 'fr', isOpinionMiningSupported: true },
    { name: 'Galician', code: 'gl' },
    { name: 'Georgian', code: 'ka' },
    { name: 'German', code: 'de', isOpinionMiningSupported: true },
    { name: 'Greek', code: 'el' },
    { name: 'Gujarati', code: 'gu' },
    { name: 'Hausa (new)', code: 'ha' },
    { name: 'Hebrew', code: 'he' },
    { name: 'Hindi', code: 'hi' },
    { name: 'Hungarian', code: 'hu' },
    { name: 'Indonesian', code: 'id' },
    { name: 'Irish', code: 'ga' },
    { name: 'Italian', code: 'it', isOpinionMiningSupported: true },
    { name: 'Japanese', code: 'ja' },
    { name: 'Javanese (new)', code: 'jv' },
    { name: 'Kannada', code: 'kn' },
    { name: 'Kazakh', code: 'kk' },
    { name: 'Central Khmer', code: 'km' },
    { name: 'Korean', code: 'ko' },
    { name: 'Kurdish (Kurmanji)', code: 'ku' },
    { name: 'Kirghiz', code: 'ky' },
    { name: 'Lao', code: 'lo' },
    { name: 'Latin (new)', code: 'la' },
    { name: 'Latvian', code: 'lv' },
    { name: 'Lithuanian', code: 'lt' },
    { name: 'Macedonian', code: 'mk' },
    { name: 'Malagasy', code: 'mg' },
    { name: 'Malay', code: 'ms' },
    { name: 'Malayalam', code: 'ml' },
    { name: 'Marathi', code: 'mr' },
    { name: 'Mongolian', code: 'mn' },
    { name: 'Nepali', code: 'ne' },
    { name: 'Norwegian', code: 'no' },
    { name: 'Odia', code: 'or' },
    { name: 'Oromo (new)', code: 'om' },
    { name: 'Pashto', code: 'ps' },
    { name: 'Persian (Farsi)', code: 'fa' },
    { name: 'Polish', code: 'pl' },
    { name: 'Portuguese (Portugal)', code: 'pt-PT', isOpinionMiningSupported: true },
    { name: 'Portuguese (Brazil)', code: 'pt-BR', isOpinionMiningSupported: true },
    { name: 'Punjabi', code: 'pa' },
    { name: 'Romanian', code: 'ro' },
    { name: 'Russian', code: 'ru' },
    { name: 'Sanskrit (new)', code: 'sa' },
    { name: 'Scottish Gaelic (new)', code: 'gd' },
    { name: 'Serbian', code: 'sr' },
    { name: 'Sindhi (new)', code: 'sd' },
    { name: 'Sinhala (new)', code: 'si' },
    { name: 'Slovak', code: 'sk' },
    { name: 'Slovenian', code: 'sl' },
    { name: 'Somali', code: 'so' },
    { name: 'Spanish', code: 'es', isOpinionMiningSupported: true },
    { name: 'Sundanese (new)', code: 'su' },
    { name: 'Swahili', code: 'sw' },
    { name: 'Swedish', code: 'sv' },
    { name: 'Tamil', code: 'ta' },
    { name: 'Telugu', code: 'te' },
    { name: 'Thai', code: 'th' },
    { name: 'Turkish', code: 'tr' },
    { name: 'Ukrainian', code: 'uk' },
    { name: 'Urdu', code: 'ur' },
    { name: 'Uighur', code: 'ug' },
    { name: 'Uzbek', code: 'uz' },
    { name: 'Vietnamese', code: 'vi' },
    { name: 'Welsh', code: 'cy' },
    { name: 'Western Frisian (new)', code: 'fy' },
    { name: 'Xhosa (new)', code: 'xh' },
    { name: 'Yiddish (new)', code: 'yi' }
];

export const detectLanguageDemoSupportedLanguages: Language[] = [
    { code: 'af', name: 'Afrikaans' },
    { code: 'sq', name: 'Albanian' },
    { code: 'am', name: 'Amharic' },
    { code: 'ar', name: 'Arabic' },
    { code: 'hy', name: 'Armenian' },
    { code: 'as', name: 'Assamese' },
    { code: 'az', name: 'Azerbaijani' },
    { code: 'eu', name: 'Basque' },
    { code: 'be', name: 'Belarusian' },
    { code: 'bn', name: 'Bangla' },
    { code: 'bs', name: 'Bosnian' },
    { code: 'bg', name: 'Bulgarian' },
    { code: 'my', name: 'Burmese' },
    { code: 'ca', name: 'Catalan' },
    { code: 'km', name: 'Central Khmer' },
    { code: 'zh', name: 'Chinese' },
    { code: 'zh-chs', name: 'Chinese-Simplified' },
    { code: 'zh-cht', name: 'Chinese-Traditional' },
    { code: 'en', name: 'English' },
    { code: 'co', name: 'Corsican' },
    { code: 'hr', name: 'Croatian' },
    { code: 'cs', name: 'Czech' },
    { code: 'da', name: 'Danish' },
    { code: 'prs', name: 'Dari' },
    { code: 'dv', name: 'Divehi' },
    { code: 'nl', name: 'Dutch' },
    { code: 'en', name: 'English' },
    { code: 'eo', name: 'Esperanto' },
    { code: 'et', name: 'Estonian' },
    { code: 'fj', name: 'Fijian' },
    { code: 'fi', name: 'Finnish' },
    { code: 'fr', name: 'French' },
    { code: 'gl', name: 'Galician' },
    { code: 'ka', name: 'Georgian' },
    { code: 'de', name: 'German' },
    { code: 'el', name: 'Greek' },
    { code: 'gu', name: 'Gujarati' },
    { code: 'ht', name: 'Haitian' },
    { code: 'ha', name: 'Hausa' },
    { code: 'he', name: 'Hebrew' },
    { code: 'hi', name: 'Hindi' },
    { code: 'mww', name: 'Hmong Daw' },
    { code: 'hu', name: 'Hungarian' },
    { code: 'is', name: 'Icelandic' },
    { code: 'ig', name: 'Igbo' },
    { code: 'id', name: 'Indonesian' },
    { code: 'iu', name: 'Inuktitut' },
    { code: 'ga', name: 'Irish' },
    { code: 'it', name: 'Italian' },
    { code: 'ja', name: 'Japanese' },
    { code: 'jv', name: 'Javanese' },
    { code: 'kn', name: 'Kannada' },
    { code: 'kk', name: 'Kazakh' },
    { code: 'rw', name: 'Kinyarwanda' },
    { code: 'ky', name: 'Kirghiz' },
    { code: 'ko', name: 'Korean' },
    { code: 'ku', name: 'Kurdish' },
    { code: 'lo', name: 'Lao' },
    { code: 'la', name: 'Latin' },
    { code: 'lv', name: 'Latvian' },
    { code: 'lt', name: 'Lithuanian' },
    { code: 'lb', name: 'Luxembourgish' },
    { code: 'mk', name: 'Macedonian' },
    { code: 'mg', name: 'Malagasy' },
    { code: 'ms', name: 'Malay' },
    { code: 'ml', name: 'Malayalam' },
    { code: 'mt', name: 'Maltese' },
    { code: 'mi', name: 'Maori' },
    { code: 'mr', name: 'Marathi' },
    { code: 'mn', name: 'Mongolian' },
    { code: 'ne', name: 'Nepali' },
    { code: 'no', name: 'Norwegian' },
    { code: 'nn', name: 'Norwegian Nynorsk' },
    { code: 'or', name: 'Odia' },
    { code: 'ps', name: 'Pashto' },
    { code: 'fa', name: 'Persian' },
    { code: 'pl', name: 'Polish' },
    { code: 'pt', name: 'Portuguese' },
    { code: 'pa', name: 'Punjabi' },
    { code: 'otq', name: 'Queretaro Otomi' },
    { code: 'ro', name: 'Romanian' },
    { code: 'ru', name: 'Russian' },
    { code: 'sm', name: 'Samoan' },
    { code: 'sr', name: 'Serbian' },
    { code: 'sn', name: 'Shona' },
    { code: 'sd', name: 'Sindhi' },
    { code: 'si', name: 'Sinhala' },
    { code: 'sk', name: 'Slovak' },
    { code: 'sl', name: 'Slovenian' },
    { code: 'so', name: 'Somali' },
    { code: 'es', name: 'Spanish' },
    { code: 'su', name: 'Sundanese' },
    { code: 'sw', name: 'Swahili' },
    { code: 'sv', name: 'Swedish' },
    { code: 'tl', name: 'Tagalog' },
    { code: 'ty', name: 'Tahitian' },
    { code: 'tg', name: 'Tajik' },
    { code: 'ta', name: 'Tamil' },
    { code: 'tt', name: 'Tatar' },
    { code: 'te', name: 'Telugu' },
    { code: 'th', name: 'Thai' },
    { code: 'bo', name: 'Tibetan' },
    { code: 'ti', name: 'Tigrinya' },
    { code: 'to', name: 'Tongan' },
    { code: 'tr', name: 'Turkish' },
    { code: 'tk', name: 'Turkmen' },
    { code: 'xh', name: 'Xhosa' },
    { code: 'yo', name: 'Yoruba' },
    { code: 'zu', name: 'Zulu' }
];

export const keyPhrasesDemoSupportedLanguages: Language[] = [
    { name: 'Afrikaans', code: 'af' },
    { name: 'Albanian', code: 'sq' },
    { name: 'Amharic', code: 'am' },
    { name: 'Arabic', code: 'ar' },
    { name: 'Armenian', code: 'hy' },
    { name: 'Assamese', code: 'as' },
    { name: 'Azerbaijani', code: 'az' },
    { name: 'Basque', code: 'eu' },
    { name: 'Belarusian', code: 'be' },
    { name: 'Bangla', code: 'bn' },
    { name: 'Bosnian', code: 'bs' },
    { name: 'Breton', code: 'br' },
    { name: 'Bulgarian', code: 'bg' },
    { name: 'Burmese', code: 'my' },
    { name: 'Catalan', code: 'ca' },
    { name: 'Chinese (Simplified)', code: 'zh-hans' },
    { name: 'Chinese-Traditional', code: 'zh-hant' },
    { name: 'Croatian', code: 'hr' },
    { name: 'Czech', code: 'cs' },
    { name: 'Danish', code: 'da' },
    { name: 'Dutch', code: 'nl' },
    { name: 'English', code: 'en' },
    { name: 'Esperanto', code: 'eo' },
    { name: 'Estonian', code: 'et' },
    { name: 'Filipino', code: 'fil' },
    { name: 'Finnish', code: 'fi' },
    { name: 'French', code: 'fr' },
    { name: 'Galician', code: 'gl' },
    { name: 'Georgian', code: 'ka' },
    { name: 'German', code: 'de' },
    { name: 'Greek', code: 'el' },
    { name: 'Gujarati', code: 'gu' },
    { name: 'Hausa', code: 'ha' },
    { name: 'Hebrew', code: 'he' },
    { name: 'Hindi', code: 'hi' },
    { name: 'Hungarian', code: 'hu' },
    { name: 'Indonesian', code: 'id' },
    { name: 'Irish', code: 'ga' },
    { name: 'Italian', code: 'it' },
    { name: 'Japanese', code: 'ja' },
    { name: 'Javanese', code: 'jv' },
    { name: 'Kannada', code: 'kn' },
    { name: 'Kazakh', code: 'kk' },
    { name: 'Central Khmer', code: 'km' },
    { name: 'Korean', code: 'ko' },
    { name: 'Kurdish', code: 'ku' },
    { name: 'Kirghiz', code: 'ky' },
    { name: 'Lao', code: 'lo' },
    { name: 'Latin', code: 'la' },
    { name: 'Latvian', code: 'lv' },
    { name: 'Lithuanian', code: 'lt' },
    { name: 'Macedonian', code: 'mk' },
    { name: 'Malagasy', code: 'mg' },
    { name: 'Malay', code: 'ms' },
    { name: 'Malayalam', code: 'ml' },
    { name: 'Marathi', code: 'mr' },
    { name: 'Mongolian', code: 'mn' },
    { name: 'Nepali', code: 'ne' },
    { name: 'Norwegian', code: 'no' },
    { name: 'Odia', code: 'or' },
    { name: 'Oromo', code: 'om' },
    { name: 'Pashto', code: 'ps' },
    { name: 'Persian', code: 'fa' },
    { name: 'Polish', code: 'pl' },
    { name: 'Portuguese (Portugal)', code: 'pt-PT' },
    { name: 'Portuguese (Brazil)', code: 'pt-BR' },
    { name: 'Punjabi', code: 'pa' },
    { name: 'Romanian', code: 'ro' },
    { name: 'Russian', code: 'ru' },
    { name: 'Sanskrit', code: 'sa' },
    { name: 'Scottish Gaelic', code: 'gd' },
    { name: 'Serbian', code: 'sr' },
    { name: 'Sindhi', code: 'sd' },
    { name: 'Sinhala', code: 'si' },
    { name: 'Slovak', code: 'sk' },
    { name: 'Slovenian', code: 'sl' },
    { name: 'Somali', code: 'so' },
    { name: 'Spanish', code: 'es' },
    { name: 'Sundanese', code: 'su' },
    { name: 'Swahili', code: 'sw' },
    { name: 'Swedish', code: 'sv' },
    { name: 'Tamil', code: 'ta' },
    { name: 'Telugu', code: 'te' },
    { name: 'Thai', code: 'th' },
    { name: 'Turkish', code: 'tr' },
    { name: 'Ukrainian', code: 'uk' },
    { name: 'Urdu', code: 'ur' },
    { name: 'Uighur', code: 'ug' },
    { name: 'Uzbek', code: 'uz' },
    { name: 'Vietnamese', code: 'vi' },
    { name: 'Welsh', code: 'cy' },
    { name: 'Western Frisian', code: 'fy' },
    { name: 'Xhosa', code: 'xh' },
    { name: 'Yiddish', code: 'yi' }
];

export const piiDemoSupportedLanguages: Language[] = [
    { code: 'zh', name: 'Chinese-Simplified' },
    { code: 'en', name: 'English' },
    { code: 'fr', name: 'French' },
    { code: 'de', name: 'German' },
    { code: 'it', name: 'Italian' },
    { code: 'ja', name: 'Japanese' },
    { code: 'ko', name: 'Korean' },
    { code: 'pt-BR', name: 'Portuguese (Brazil)' },
    { code: 'pt', name: 'Portuguese (Portugal)' },
    { code: 'es', name: 'Spanish' }
];

export const summarizationDemoSupportedLanguages: Language[] = [
    { code: 'zh', name: 'Chinese-Simplified' },
    { code: 'en', name: 'English' },
    { code: 'fr', name: 'French' },
    { code: 'de', name: 'German' },
    { code: 'it', name: 'Italian' },
    { code: 'ja', name: 'Japanese' },
    { code: 'ko', name: 'Korean' },
    { code: 'es', name: 'Spanish' },
    { code: 'he', name: 'Hebrew' },
    { name: 'Polish', code: 'pl' }
    // { code: 'pt-BR', name: 'Portuguese (Brazil)' },
    // { code: 'pt', name: 'Portuguese (Portugal)' }
];

export const textSummarizationDemoSupportedLanguages: Language[] = [
    { code: 'zh', name: 'Chinese-Simplified' },
    { code: 'en', name: 'English' },
    { code: 'fr', name: 'French' },
    { code: 'de', name: 'German' },
    { code: 'it', name: 'Italian' },
    { code: 'ja', name: 'Japanese' },
    { code: 'ko', name: 'Korean' },
    { code: 'es', name: 'Spanish' },
    // { code: 'pt-BR', name: 'Portuguese (Brazil)' },
    { code: 'pt', name: 'Portuguese' },
    { code: 'he', name: 'Hebrew' },
    { name: 'Polish', code: 'pl' }
];

export const taForHealthDemoPreviewModelSupportedLanguages: Language[] = [
    { code: 'en', name: 'English' },
    { code: 'fr', name: 'French' },
    { code: 'de', name: 'German' },
    { code: 'he', name: 'Hebrew' },
    { code: 'it', name: 'Italian' },
    { code: 'es', name: 'Spanish' },
    { code: 'pt', name: 'Portuguese' }
];

export const taForHealthDemoGAModelSupportedLanguages: Language[] = [{ code: 'en', name: 'English' }];

export const rtlLanguages: Language[] = [
    { code: 'ar', name: 'Arabic' },
    { code: 'fa', name: 'Persian' },
    { code: 'he', name: 'Hebrew' },
    { code: 'ku', name: 'Kurdish' },
    { code: 'ps', name: 'Pashto' },
    { code: 'sd', name: 'Sindhi' },
    { code: 'ug', name: 'Uighur' },
    { code: 'ur', name: 'Urdu' },
    { code: 'yi', name: 'Yiddish' }
];

export const wordTokenizedLanguages: Language[] = [
    { code: 'ar', name: 'Arabic' },
    { code: 'fa', name: 'Persian' },
    { code: 'he', name: 'Hebrew' },
    { code: 'ku', name: 'Kurdish' },
    { code: 'ps', name: 'Pashto' },
    { code: 'sd', name: 'Sindhi' },
    { code: 'ug', name: 'Uighur' },
    { code: 'ur', name: 'Urdu' },
    { code: 'yi', name: 'Yiddish' },
    { code: 'as', name: 'Assamese' },
    { code: 'bn', name: 'Bangla' },
    { code: 'gu', name: 'Gujarati' },
    { code: 'hi', name: 'Hindi' },
    { code: 'km', name: 'Central Khmer' },
    { code: 'kn', name: 'Kannada' },
    { code: 'ml', name: 'Malayalam' },
    { code: 'mr-in', name: 'Marathi' },
    { code: 'mr', name: 'Marathi' },
    { code: 'my', name: 'Burmese' },
    { code: 'ne', name: 'Nepali' },
    { code: 'or', name: 'Odia' },
    { code: 'pa', name: 'Punjabi' },
    { code: 'sa', name: 'Sanskrit' },
    { code: 'si', name: 'Sinhala' },
    { code: 'ta', name: 'Tamil' },
    { code: 'te', name: 'Telugu' }
];
